import React, { useRef, useState } from 'react';
import { connect } from 'react-redux';

import { toggleModal } from 'apps/auth/actions/appAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import InputsConfirmPassword from 'apps/auth/components/form/InputsConfirmPassword';
import Form from 'apps/auth/components/form-multi/Form';
import ProfileSmsConfirmModal from 'apps/auth/components/profile/settings/ProfileSmsConfirmModal';
import BasePage from 'apps/auth/components/utils/BasePage';
import ModalNew from 'apps/auth/components/utils/ModalNew';
import { AUTH_CHANGE_PASSWORD_ACTION, AUTH_SETTINGS } from 'apps/auth/constants/UrlConstants';

const FORM_NAME = 'changePassword';

const ChangePasswordPage = (props) => {
    const popupRef = useRef(null);
    const modalRef = useRef(null);
    const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);

    const submitHandler = (fields, data) => {
        if (data.extra && data.extra.smsConfirmation) {
            props.toggleModal(true, <ProfileSmsConfirmModal popupRef={popupRef} />);
        }
    };

    return (
        <>
            <CommonPage backUrl={AUTH_SETTINGS} hasBottomPanel showChat={false}>
                <HeaderPanel title={props.headerTitle} subtitle={props.headerGrayTitle} />
                <Form
                    id="restorepassword_form_id"
                    action={AUTH_CHANGE_PASSWORD_ACTION}
                    formName={FORM_NAME}
                    onSubmitHandler={submitHandler}
                    fields={props.fields}
                >
                    <fieldset>
                        <InputsConfirmPassword
                            formName={FORM_NAME}
                            password={props.fields.password}
                            confirmPassword={props.fields.confirmPassword}
                            setIsSubmitDisabled={setIsSubmitDisabled}
                        />
                    </fieldset>
                    <FixedBottomPanel isRightAligned>
                        <Button type="submit" raised={true} caption={props.changePasswordSubmit} disabled={isSubmitDisabled} />
                    </FixedBottomPanel>
                </Form>
            </CommonPage>
            <PopupNew ref={popupRef} />
            <ModalNew ref={modalRef} />
        </>
    );
};
const mapStateToProps = (state) => {
    return {
        lang: state.language.lang,
        fields: state.form[FORM_NAME].fields,
        changePasswordSubmit: state.messages.pageMessages.changePasswordSubmit,
        headerTitle: state.messages.pageMessages.headerTitle,
        headerGrayTitle: state.messages.pageMessages.headerGrayTitle,
    };
};
export default connect(mapStateToProps, {
    toggleModal,
})(BasePage(ChangePasswordPage));
